<template>
    <Head title="Meu Perfil" />
    <AuthenticatedLayout>
        <Heading title="Meu Perfil" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28"/>
        <article class="component-background-desktop component-background-mobile pt-10 pb-14 px-4 xl:px-[16vw] min-h-[80vh]">
            <button @click="goBack" :class="stateBack" class="back-sm hover:text-blue-600 hover:underline text-blue-500">Voltar</button>
            <div class="sm:px-5 xl:max-w-[350px] xl:min-w-[350px] text-primary">
                <h2 class="text-3xl text-primary font-semibold text-left xl:py-6 sm:py-4">Nova Senha</h2>
                <p class="text-md pb-4">Crie uma <strong>senha</strong> forte que só você
                    <br /> saiba. Ela precisa ter:</p>

                <ul>
                    <li class="flex items-center pb-1">
                        <Icon name="Sucesso" :class="hasTenChar ? '!text-success' : '!text-gray-500'"/>
                        <p class="ml-2.5 text-sm">Mínimo de 10 caracteres</p>
                    </li>

                    <li class="flex items-center pb-1">
                        <Icon name="Sucesso" :class="hasUpperCase ? '!text-success' : '!text-gray-500'" />
                        <p class="ml-2.5 text-sm">Um caractere maiúsculo</p>
                    </li>

                    <li class="flex items-center pb-1">
                        <Icon name="Sucesso" :class="hasLowerCase ? '!text-success' : '!text-gray-500'" />
                        <p nome="isValid" class="ml-2.5 text-sm">Um caractere minúsculo</p>
                    </li>

                    <li class="flex items-center pb-1">
                        <Icon name="Sucesso" :class="hasNumber ? '!text-success' : '!text-gray-500'" />
                        <p class="ml-2.5 text-sm">Um número</p>
                    </li>

                    <li class="flex items-center">
                        <Icon name="Sucesso" :class="hasSpecialChar ? '!text-success' : '!text-gray-500'" />
                        <p class="ml-2.5 text-sm">Um caractere especial (ex.: !@#$%)</p>
                    </li>
                </ul>


                <form @submit.prevent="submit" class="mb-4">
                    <ul class="pt-6">
                        <li class="mb-4">
                            <label class="mb-1 mr-5 flex font-bold">Senha</label>
                            <Input
                                placeholder="*********"
                                :state="inputState"
                                id="password"
                                v-model="form.password"
                                type="password"
                                required
                                autofocus
                                class="text-black"
                            />
                            <p class="text-[10px]">
                                Força da senha:
                                <span :class="powerPassword.classes">{{ powerPassword.text }}</span>
                            </p>
                        </li>

                        <li class="mb-8">
                            <label class="mb-1 mr-5 flex font-bold">Confirme sua senha</label>
                            <Input
                                placeholder="*********"
                                id="confirmPassword"
                                :state="isEqualInputState"
                                v-model="confirmPassword"
                                type="password"
                                required
                                autofocus
                                class="text-black"
                            />
                            <p v-if="!isEqual" class="text-[10px] text-error">
                                Senhas não coincidem
                            </p>
                            <p v-if="isEqual" class="text-[10px]">
                                Força da senha:
                                <span :class="powerPassword.classes">{{ powerPassword.text }}</span>
                            </p>
                        </li>

                        <li>
                            <Button @click.prevent="submit()"
                            :enabled="allIsValid && isEqual ? true : false">
                                Alterar Senha
                            </Button>
                        </li>
            <transition>
                <div v-if="$page.props.flash.success" class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-70 flex justify-center items-center">
                    <div class="bg-white border-[1px] rounded-[4px] mx-2.5 w-3/12 sm:w-8/12 px-4 py-4 leading-9">
                        <button class="float-right" @click="$page.props.flash.success = ''">
                            <Icon name="Fechar"/>
                        </button>
                        <h1 class="text-[20px] font-bold text-primary">Senha Alterada</h1>
                        <p class="text-[16px] leading-6">Sua senha foi alterada.</p>
                        <div class="flex justify-center">
                            <a href="/login"
                                class="
                                my-2
                                place-self-center
                                justify-items-center
                                items-center
                                text-align-center
                                text-white
                                font-semibold
                                bg-primary
                                border rounded
                                hover:bg-yellow-300
                                hover:border transparent
                                hover:text-primary
                                p-2
                                sm:mt-2
                                ">
                                Fazer login
                            </a>
                            <!-- <Button class="w-5/12 my-2 place-self-center" @click.prevent="window.location.href='/login'">Fazer login</Button> -->
                        </div>
                    </div>
                </div>
            </transition>
                    </ul>
                </form>

                <div v-if="$page.props.flash.error">
                    {{ $page.props.flash.error }}
                </div>

                <!-- <div v-if="$page.props.flash.success">
                    {{ $page.props.flash.success }}
                </div> -->
            </div>


        </article>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Input from "@/Components/UI/Form/Input.vue";
import { Head } from "@inertiajs/inertia-vue3";
import Heading from '@/Components/UI/Texts/Heading.vue';
import Back from '@/Components/UI/Back.vue';
import Button from '@/Components/Button.vue';
import Icon from '@/Components/UI/Icons/Icon.vue';



export default {
    components: {
        AuthenticatedLayout,
        Head,
        Heading,
        Back,
        Input,
        Button,
        Icon
    },
    data() {
        return{
            showSuccessModal: false,
            showModal: true,
            confirmPassword: '',
            form: this.$inertia.form({
                password: ''
            }),
        }
    },
    methods: {
        submit() {
            if(this.allIsValid && this.isEqual) {
                // console.log(this.form)
                this.form.post('/my-profile/save-password');
            }
        },
        goBack(){
            return window.history.go(-1);
        },
        isValid(fn) {
            if(fn) {
                return 'Sucesso'
            } else {
                return 'Erro'
            }
        },
    },
    computed: {
        hasTenChar() {
            return this.form.password.length > 9;
        },
        hasUpperCase() {
            var re = /([A-Z])/g
            return re.test(this.form.password);
        },
        hasLowerCase() {
            var re = /([a-z])/g
            return re.test(this.form.password);
        },
        hasNumber() {
            var re = /([0-9])/g
            return re.test(this.form.password);
        },
        hasSpecialChar() {
            var re = /[^A-Za-z0-9]/
            return re.test(this.form.password);
        },
        isEqual() {
            return this.form.password === this.confirmPassword;
        },
        allIsValid() {
            return (this.hasTenChar && this.hasUpperCase && this.hasLowerCase && this.hasNumber && this.hasSpecialChar)
        },
        inputState() {
            if(this.form.password) {
                    if(this.allIsValid) {
                return 'success'
                } else {
                    return 'error'
                }
            }
        },
        isEqualInputState() {
            if(this.form.password) {
                if(this.isEqual) {
                    return 'success'
                } else {
                    return 'error'
                }
            }
        },
        powerPassword() {
            if(this.allIsValid) {
                return {
                    classes: 'text-success',
                    text: 'forte'
                }
            }
            else if(this.hasTenChar) {
                return {
                classes: 'text-yellow',
                text: 'média'
                }
            }
            else {
                return {
                classes: 'text-error',
                text: 'fraca'
                }
            }
        }
    }
};
</script>
